/* @flow */
import * as React from 'react';
import { translate } from 'react-i18next';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';

const ExchangeDetails = props => {
  const { t, options } = props;

  const header = options.in_use
    ? t('general:assets.labels.exchange_header_current_asset')
    : t('general:assets.labels.exchange_header_previous_asset');

  return (
    <div>
      <h3>{header}</h3>
      <table>
        <tbody>
          <tr>
            <td>
              <b>{t('general:assets.labels.number')}:</b>
            </td>
            <td>{options.asset_number}</td>
          </tr>
          <tr>
            <td>
              <strong>{t('general:manufacturer')}:</strong>
            </td>
            <td>{options.manufacturer}</td>
          </tr>
          {!options.owned && (
            <tr>
              <td>
                <strong>{t('general:assets.labels.ml_product_type')}:</strong>
              </td>
              <td>{options.er_product_type}</td>
            </tr>
          )}
          <tr>
            <td>
              <strong>{t('general:model')}:</strong>
            </td>
            <td>{options.model}</td>
          </tr>
          <tr>
            <td>
              <strong>{t('general:description')}:</strong>
            </td>
            <td>{options.description}</td>
          </tr>
          <tr>
            <td>
              <strong>{t('general:assets.labels.exchange_date')}:</strong>
            </td>
            <td>{options.date}</td>
          </tr>
        </tbody>
      </table>

      <Link to={'/assets/' + options.asset_id}>
        <Button variant="contained" color="primary" disabled={options.is_its_own_rpl}>
          {t('general:actions.view_details')}
        </Button>
      </Link>
    </div>
  );
};

export default translate()(ExchangeDetails);
